'use client';

import React, { useEffect } from 'react';
import { CustomButton } from '@/components/ui/CustomButton';
import { useRegistration } from '@/features/b2b/register/context/RegistrationContext';

export const Step1Form = ({ formData, handleInputChange, handleSubmitClick, errors }) => {
  const { registrationEmail } = useRegistration();

  useEffect(() => {
    if (registrationEmail) {
      handleInputChange({
        target: {
          name: 'email',
          value: registrationEmail,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <h1 className="text-[#373945] text-4xl font-semibold mb-6 text-left md:text-center">
        Welcome to Pure
      </h1>

      <p className="text-[#5B5D6B] text-base font-450 mb-6 text-left md:text-center">
        Register with us effortlessly in <span className="font-semibold">three simple steps.</span>
      </p>

      <label htmlFor="firstName" className="text-[#373945] text-base font-medium mb-2 block">
        First name*
      </label>

      <input
        type="text"
        id="firstName"
        name="firstName"
        value={formData.firstName}
        onChange={handleInputChange}
        placeholder="John"
        className={`w-full p-4 border rounded-lg mb-6 focus:outline-none ${
          errors.firstName
            ? 'border-2 border-[#D32F2F] focus:border-[#D32F2F] focus:ring-[#D32F2F]'
            : 'border-gray-300 focus:border-[#006EB7]'
        }`}
      />

      <label htmlFor="lastName" className="text-[#373945] text-base font-medium mb-2 block">
        Second name*
      </label>

      <input
        type="text"
        id="lastName"
        name="lastName"
        value={formData.lastName}
        onChange={handleInputChange}
        placeholder="Smith"
        className={`w-full p-4 border rounded-lg mb-6 focus:outline-none ${
          errors.lastName
            ? 'border-2 border-[#D32F2F] focus:border-[#D32F2F] focus:ring-[#D32F2F]'
            : 'border-gray-300 focus:border-[#006EB7]'
        }`}
      />

      <label htmlFor="email" className="text-[#373945] text-base font-medium mb-2 block">
        Company email*
      </label>

      <input
        type="email"
        id="email"
        name="email"
        value={registrationEmail || formData.email}
        onChange={handleInputChange}
        placeholder="name@example.co.uk"
        className={`w-full p-4 border rounded-lg mb-12 focus:outline-none ${
          errors.email
            ? 'border-2 border-[#D32F2F] focus:border-[#D32F2F] focus:ring-[#D32F2F]'
            : 'border-gray-300 focus:border-[#006EB7]'
        }`}
      />
      <div className="flex mb-12 px-4">
        <label
          htmlFor="privacyAgreed"
          className="flex items-center cursor-pointer"
        >
          <input
            type="checkbox"
            id="privacyAgreed"
            name="privacyAgreed"
            checked={formData.privacyAgreed}
            onChange={handleInputChange}
            className="sr-only peer"
          />
          <span
            className={`mr-2 h-5 w-5 flex items-center justify-center border-2 rounded-md transition duration-200 peer-focus:ring-2 peer-focus:ring-offset-2 peer-focus:ring-[#006EB7] ${
              errors.privacyAgreed
                ? 'border-[#D32F2F] bg-red-100'
                : formData.privacyAgreed
                  ? 'border-[#006EB7] bg-[#006EB7]'
                  : 'border-[#CBCDD6] bg-white hover:bg-[#93C6E5] hover:border-[#006EB7]'
            }`}
          >
            {formData.privacyAgreed && (
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 10 8" fill="none" aria-hidden="true">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8.83114 1.07673C9.01941 1.20225 9.05575 1.43755 8.91231 1.60228L4.34089 6.85227C4.26594 6.93834 4.15215 6.99189 4.02875 6.99915C3.90536 7.00642 3.7844 6.96668 3.69695 6.89016L1.12553 4.64017C0.958158 4.49373 0.958158 4.25629 1.12553 4.10984C1.29289 3.9634 1.56425 3.9634 1.73162 4.10984L3.95628 6.05643L8.23051 1.14775C8.37395 0.983014 8.64287 0.951218 8.83114 1.07673Z"
                  fill="white"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            )}
          </span>
          <span className="text-sm text-[#373945] font-450">
            I accept the <a href="https://puremediastorage.blob.core.windows.net/pure-web-media/general_process/terms-of-business.pdf" className="plain-text-link plain-text-link--underline">Terms of Use</a> and <a href="/privacy-policy"
              className="plain-text-link plain-text-link--underline">Privacy Policy.</a>
          </span>
        </label>
      </div>

      <CustomButton
        variant="primaryLarge"
        type="button"
        className="disabled:opacity-50 disabled:cursor-not-allowed w-full md:w-3/4 md:mx-auto mb-12"
        /*disabled={!formValid}*/
        onClick={handleSubmitClick}
      >
        Next step
      </CustomButton>
    </>
  );
};
